export default __webpack_public_path__ + "static/media/FaqPiqNew.31deca68.svg";